import { AffiliateUpdateApiInterface } from 'modules/affiliate-program/types/affiliate-program-interface'
import httpClient from 'shared/utils/http-client'

export const AFFILIATE_PROGRAM_API = '/api/dashboard/customer/affiliate-program'

export const updateCommission = (id: number, data: AffiliateUpdateApiInterface) =>
  httpClient.put(`/api/dashboard/customer/offer/offers/${id}/update-commission`, data)
